export default {
  namespaced: true,
  state: {
    tabs: ''
  },
  // mutations 修改器，用于修改state中的定义的状态变量,同步
  mutations: {
    setTabs(state, payload) {
      state.tabs = payload
    }
  },
  // 存放异步操作，由 action 去触发 mutation
  actions: {}
}
